var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardCrashanalysisIssuedetailCopyreportIconNormal = function SvgNewcsDashboardCrashanalysisIssuedetailCopyreportIconNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_crashanalysis_issuedetail_copyreport_icon_normal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M586 281h12v14h-12z",
    "data-name": "\\u77E9\\u5F62 363"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_crashanalysis_issuedetail_copyreport_icon_normal_svg__a)",
    transform: "translate(-586 -281)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6669fe",
    d: "M587.324 294a1.326 1.326 0 0 1-1.324-1.33v-6.71a1.326 1.326 0 0 1 1.324-1.325h1.318v-1.316a1.326 1.326 0 0 1 1.325-1.325h6.71a1.326 1.326 0 0 1 1.325 1.325v6.709a1.326 1.326 0 0 1-1.325 1.325h-1.316v1.317a1.326 1.326 0 0 1-1.325 1.325Zm-.223-8.034v6.71a.225.225 0 0 0 .223.224h6.71a.224.224 0 0 0 .223-.224v-6.71a.224.224 0 0 0-.223-.224h-6.71a.224.224 0 0 0-.224.228Zm6.934-1.325a1.326 1.326 0 0 1 1.325 1.325v4.294h1.316a.224.224 0 0 0 .223-.224v-6.709a.224.224 0 0 0-.223-.224h-6.71a.224.224 0 0 0-.223.224v1.316Z",
    "data-name": "\\u8054\\u5408 25"
  }))));
};
export default SvgNewcsDashboardCrashanalysisIssuedetailCopyreportIconNormal;